import type { z } from 'zod';

import { companyQuerySchema } from '@/_pages/companies/shared/schemas';

export const companyFilteredSchema = companyQuerySchema.pick({
  id: true,
  name: true,
  logo: true,
  account_number: true,
  contacts: true,
});

export type CompanyFilteredSchema = z.infer<typeof companyFilteredSchema>;
